export const PRODUCT_TYPES = ['Pokemon', 'Magic', 'Yu-Gi-Oh!', 'Lorcana', 'Gundam', 'Riftbound'];
